Vue.component('destination', {
	template: '#vue-destination',
	props: {
		country: { default: '' },
		region: { default: '' },
		city: { default: '' },
		tpl: { default: 0 }
	},
	computed: {
		countryForUrl: function () {
			return this.forUrl(this.country);
		},
		regionForUrl: function () {
			return this.forUrl(this.region);
		},
		cityForUrl: function () {
			return this.forUrl(this.city);
		}
	},
	methods: {
		noPl: function (string) {
			const accents = "ÀÁÂÃÄÅĄĀāàáâãäåąßÒÓÔÕÕÖØŐòóôőõöøĎďDŽdžÈÉÊËĘèéêëęðÇçČčĆćÐÌÍÎÏĪìíîïīÙÚÛÜŰùűúûüĽĹŁľĺłÑŇŃňñńŔŕŠŚŞšśşŤťŸÝÿýŽŻŹžżźđĢĞģğ";
			const accentsOut = "AAAAAAAAaaaaaaaasOOOOOOOOoooooooDdDZdzEEEEEeeeeeeCcCcCcDIIIIIiiiiiUUUUUuuuuuLLLlllNNNnnnRrSSSsssTtYYyyZZZzzzdGGgg";

			let stringReturn = string.split("").map(function (letter, index) {
				let accentIndex = accents.indexOf(letter);
				return accentIndex !== -1 ? accentsOut[accentIndex] : letter;
			}).join("");

			return stringReturn;
		},
		forUrl: function (string) {
			return this.noPl(string).toLowerCase().replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/\ ]/gi, '-').replace(/-+/g, "-");
		}
	}
});